export var ColumnError;
(function (ColumnError) {
})(ColumnError || (ColumnError = {}));
var ColumnRequest = /** @class */ (function () {
    function ColumnRequest(reportId, isCustomizedReport, columnName, query) {
        this.knownErrorCodes = Object.values(ColumnError);
        this.path = isCustomizedReport
            ? "my/customized-reports/".concat(encodeURIComponent(reportId), "/columns/").concat(String(columnName), "/values?").concat(String(query.searchParams))
            : "reports/".concat(encodeURIComponent(reportId), "/columns/").concat(String(columnName), "/values?").concat(String(query.searchParams));
    }
    return ColumnRequest;
}());
export { ColumnRequest };
